export enum WorkflowActionResults {
    FailedToIdentifyTargetRegister = "FailedToIdentifyTargetRegister",
    InvalidAction = "InvalidAction",
    InvalidActionId = "InvalidActionId",
    InvalidFiling = "InvalidFiling",
    InvalidFilingId = "InvalidFilingId",
    InvalidTargetStatusId = "InvalidTargetStatusId",
    Success = "Success"
}